export default __webpack_public_path__ + "media/zurb/img/icons/favicon/favicon-196x196-f64c2ae9abf760c3934dfb8cb5c71f17.png";